import UserFormFieldItemStatus from "./user-status-field-form-item";

const UserFormItems = {
    StatusSelect: UserFormFieldItemStatus,
};

export default UserFormItems;